<template>
  <div class="activityDetialBox">
    <Download></Download>
    <div class="main">
      <div class="top">
        <div class="img">
          <img :src="info.image" alt />
        </div>
        <div class="title">{{info.name}}</div>
        <div class="time">
          <p>报名时间: {{util.changeTime({time:info.starttimepoint,line:"."})}} - {{util.changeTime({time:info.endtimepoint,line:"."})}}</p>
          <p>活动时间: {{util.changeTime({time:info.starttime,line:"."})}} - {{util.changeTime({time:info.endtime,line:"."})}}</p>
          <p>活动地址: {{info.address}}</p>
        </div>
        <div class="sponsor" v-if="info.organizationid" @click="goOrganization()">
          <div class="titTop">
            <p>主办单位</p>
            <span></span>
          </div>
          <div class="institution">
            <img :src="organization.logo" alt />
            <div class="institutionInfo">
              <div class="tit">{{organization.name}}</div>
              <p>{{organization.businesshours}}</p>
              <div class="location">
                <div>
                  <i></i>
                  <span>{{organization.address}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sponsor">
          <div class="titTop">
            <p>活动简介</p>
            <span></span>
          </div>
        </div>
      </div>
      <div class="content" v-html="info.memo"></div>
    </div>
    <div class="btn" @click="apply()">
      <p
        :class="['active',info.activitystatus=='1001'?'active':'over']"
      >{{info.activitystatus=='1001'?'立即报名':'已结束'}}</p>
    </div>
  </div>
</template>

<script>
import Download from "@/components/download.vue";

export default {
  metaInfo() {
    return {
      title: "活动详情",
    };
  },
  name: "activityDetial",
  data() {
    return {
      info: "",
      activityid: "",
      organization: "",
    };
  },
  components: {
    Download,
  },
  mounted() {
    this.activityid = this.$route.query.activityid
      ? this.$route.query.activityid
      : "709783619182264320";
    this.getDetial();
  },
  methods: {
    getDetial() {
      this.$post("gart-common-api/api/scm/activity/queryActivityById", {
        activityid: this.activityid,
      }).then((res) => {
        if (res.code == 1) {
          this.info = res.data;
          if (this.info.organizationid) {
            this.getOrganization();
          }
          this.shareLink();
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },

    getOrganization() {
      this.$post("gart-common-api/api/crm/organization/queryByOrganization", {
        teaminfoid: this.info.organizationid,
      }).then((res) => {
        if (res.code == 1) {
          this.organization = res.data;
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    apply() {
      this.util.downLoad(this, { open: true });
    },

    shareLink() {
      var _this = this;
      var url =
        _this.$store.state.state.shareUrl +
        "#/h5/index/activityDetial?activityid=" +
        _this.activityid;
      var data = {
        title: this.info.sharetitle,
        desc: this.info.sharesummary ? this.info.sharesummary : "", // 分享描述
        url: url,
        imgUrl: this.info.shareicon,
      };
      this.util.shareLink(this, data).then(function () {});
    },
    goOrganization() {
      this.$router.push({
        path: "/h5/serve/agency",
        query: { teamInfoId: this.organization.teaminfoid },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.activityDetialBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow: auto;
    padding: 16px 16px;
    .top {
      .title {
        font-size: 22px;
        line-height: 30px;
        color: #2d2d2d;
        font-weight: bold;
        margin-top: 24px;
      }

      .img {
        width: 343px;
        height: 257px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .time {
        margin: 24px 0;
        p {
          font-size: 14px;
          font-weight: 300;
          color: #2d2d2d;
          line-height: 24px;
        }
      }
      .sponsor {
        .titTop {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          p {
            font-size: 14px;
            font-weight: bold;
            color: rgba(53, 54, 60, 0.6);
          }
          span {
            display: inline-block;
            margin-left: 8px;
            background: rgba(224, 224, 224, 0.5);
            flex: 1;
            height: 1px;
          }
        }
        .institution {
          display: flex;
          flex-direction: row;
          padding: 16px 0 24px;

          img {
            width: 88px;
            height: 88px;
            border-radius: 4px;
          }
          .institutionInfo {
            flex: 1;
            margin-left: 12px;
            > .tit {
              font-size: 14px;
              font-weight: bold;
              line-height: 20px;
              color: #2d2d2d;
            }
            p {
              font-size: 12px;
              font-weight: 300;
              line-height: 17px;
              color: rgba(45, 45, 45, 0.56);
              margin: 5px 0 29px;
            }
            .location {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              > div {
                display: flex;
                flex-direction: row;
                i {
                  width: 16px;
                  height: 16px;
                  background: url(../../../assets/img/h5/address.png);
                  background-size: 16px 16px;
                }
                span {
                  width: 220px;
                  font-size: 12px;
                  font-weight: 300;
                  line-height: 17px;
                  color: rgba(45, 45, 45, 0.6);
                  margin-left: 4px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
      }
    }
    .content {
      margin: 14px auto 16px;
      flex: 1;
      overflow: auto;
    }
  }
  .btn {
    background: #ffffff;
    padding: 12px 24px 24px 24px;
    p {
      // background: #c94c4c;
      border-radius: 8px;
      color: #ffffff;
      font-size: 14px;
      line-height: 20px;
      font-weight: bold;
      padding: 14px 0;
      text-align: center;
    }
    .active {
      background: #c94c4c;
    }
    .over {
      background: #d5d5d5;
    }
  }
}
</style>
